import Aperol from '../../images/aperol_babcia_dziadek.jpg';
import Restaurant from '../../images/restaurant_babcia_dziadek.jpg';

type Props = {};

export default function BabciaDziadek({}: Props) {
	return (
		<div className="flex flex-col gap-3">
			<div className="flex items-center gap-10  mb-8">
				<img
					src={Aperol}
					alt="aperol"
					className="mx-auto rounded-lg shadow-lg shadow-gray-400/50 w-[40%] object-cover h-[400px]"
				/>
				<img
					src={Restaurant}
					alt="restaurant"
					className="mx-auto rounded-lg shadow-lg shadow-gray-400/50 w-[40%] object-cover h-[400px]"
				/>
			</div>
			<p className="text-3xl text-center font-medium text-customBlue">
				Jak już się nam uda dotrzeć do tych wspaniałych Włoch...
			</p>
			<p className="text-lg text-center font-medium mb-4">
				...to małe zaproszonko do jakiejś fajnej restauracji na obiad. I może
				jakiś aperolek również wleci :P
			</p>
		</div>
	);
}
